module.exports = __webpack_public_path__ + "static/img/AppStore-icon.c73900e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/AppStore-icon.svg
// module id = 1146
// module chunks = 1